export class UsersModel{
  userID ='';
  userName = '';
  enabled =  '';
  empID = '';
  groupCode ='';
  password ='';
  userID1 = '';
  modifiedDate = '2021-01-01';
  compCode = '1';
  iTPicture;
  token='';
}
